import { useState, useCallback } from 'react'

interface ShareButtonProps {
  title: string
  text: string
  url: string
  imageUrl?: string
}

export default function ShareButton({ title, text, url }: ShareButtonProps) {
  const [feedback, setFeedback] = useState<string | null>(null)

  const showFeedback = useCallback((message: string) => {
    setFeedback(message)
    setTimeout(() => setFeedback(null), 2000)
  }, [])

  const handleShare = useCallback(async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, text, url })
        showFeedback('Shared!')
      } catch (err) {
        if ((err as DOMException).name !== 'AbortError') {
          await navigator.clipboard.writeText(url)
          showFeedback('Copied!')
        }
      }
    } else {
      await navigator.clipboard.writeText(url)
      showFeedback('Copied!')
    }
  }, [title, text, url, showFeedback])

  return (
    <button
      onClick={handleShare}
      className="flex items-center gap-1.5 px-3 py-1.5 text-sm text-text-secondary hover:text-neon transition-colors rounded-lg hover:bg-bg-elevated cursor-pointer"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
        <polyline points="16 6 12 2 8 6" />
        <line x1="12" y1="2" x2="12" y2="15" />
      </svg>
      {feedback ?? 'Share'}
    </button>
  )
}
